// config.js

const API_ENDPOINT = 'https://server.misteryinvestigation.it'
const WEBSOCKET_ENDPOINT = 'wss://server.misteryinvestigation.it'

module.exports = {
  API_ENDPOINT,
  WEBSOCKET_ENDPOINT,
}
